import React from 'react'
import ReactECharts from 'echarts-for-react'
import { type ReportsV2 } from '../../../models/Report'
import { Card } from '@mui/material'
import { blue, grey } from '../../../colors'

interface SurveyScoreChartProps {
  reports: ReportsV2
}

export const SurveyScoreChart: React.FC<SurveyScoreChartProps> = ({ reports }) => {
  const option = {
    title: {
      text: 'Survey Score',
      left: 'center',
      top: 10,
      textStyle: {
        fontSize: 24,
        fontWeight: 'bold',
        color: grey[250]
      }
    },
    tooltip: { trigger: 'axis' },
    xAxis: {
      type: 'category',
      data: reports?.titles,
      showTicks: { show: false },
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        fontWeight: 'bold',
        margin: 26,
        fontSize: 14,
        color: grey[850]
      }

    },
    yAxis: {
      type: 'value',
      axisLabel: {
        fontWeight: 'bold',
        color: grey[850],
        fontSize: 16
      },
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: true },
      nameGap: 40,
      nameRotate: 0,
      minInterval: 1
    },
    series: [
      {
        name: 'Score',
        data: reports?.surveyScores || [],
        smooth: true,
        symbol: 'circle',
        nameGap: 30,
        axisLine: { show: false },
        type: 'line',
        symbolSize: 14,
        lineStyle: {
          width: 3,
          color: blue[600]
        }
      }
    ]
  }

  return (
    <Card>
      <ReactECharts option={option} style={{ width: '100%', height: '400px', maxHeight: 500 }} />
    </Card>
  )
}
